import test from 'ramda/src/test'
import { VERIFY_ACCOUNT_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import { POST_SIGN_UP, SET_REDIRECT_URL } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { emailRe } from 'root/src/shared/util/regexes'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import outputs from 'root/cfOutput'
import authApi from 'root/src/shared/util/authApi'
import { apiIdentifier } from 'root/src/shared/constants/aws'
import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'

const { domainName } = outputs

export default ({
	email,
	password,
	userGroup,
	redirectRoute,
	newsletterSub,
}) => async () => {
	if (redirectRoute) {
		await invokeApiRequest(SET_REDIRECT_URL, { email, redirectRoute })
	}
	if (!test(emailRe, email)) {
		throw { email: 'Please input correct email address.' }
	}
	const { error } = await authApi.signUp({
		email,
		password,
		group: userGroup,
		redirectUrl: `https://${apiIdentifier}.${domainName}?endpointId=${POST_SIGN_UP}`,
		data: {
			newsletterSub,
		},
	})

	if (error) {
		throw error
	}

	return pushRouteClient({ routeId: VERIFY_ACCOUNT_ROUTE_ID })
}
